import { render, staticRenderFns } from "./monitorLift.vue?vue&type=template&id=3bef84a0&scoped=true&"
import script from "./monitorLift.vue?vue&type=script&lang=js&"
export * from "./monitorLift.vue?vue&type=script&lang=js&"
import style0 from "./monitorLift.vue?vue&type=style&index=0&id=3bef84a0&scoped=true&lang=css&"
import style1 from "./monitorLift.vue?vue&type=style&index=1&id=3bef84a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef84a0",
  null
  
)

export default component.exports